import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-check-email',
    templateUrl: './check-email.component.html',
    styleUrls: ['./check-email.component.scss'],
    standalone: false
})
export class CheckEmailComponent implements OnInit {
  public emailFromStorage : string = '';
  public userEmail : string; 
  constructor(private router : ActivatedRoute) { }

  ngOnInit(): void {
    this.emailFromStorage = sessionStorage.getItem('email');
    if(this.userEmail){
      this.userEmail = this.emailFromStorage;
    } else {
      this.router.queryParams.subscribe(
        params =>{
          this.userEmail = params['email']
        })
    }
  }

}
